import React, { Suspense } from 'react'
import { ScopeProviderWithInitializer } from 'components/scope-provider'
import { createStakingStorageAtoms } from './storage/index'
import StakingPageLoading from './loading'
import { StakingPageWrapper } from './staking-page-wrapper'
import { StakingPageContainer } from './styled'
import { zeroAddress } from 'viem'
import { useAtomValue } from 'jotai'
import { userAccountAtom } from 'context/account'

export const StakingIndexPage: React.FC = () => {
  const userAddress = useAtomValue(userAccountAtom) ?? zeroAddress
  return (
    <StakingPageContainer>
      <ScopeProviderWithInitializer
        atomValues={createStakingStorageAtoms(userAddress)}
        key={userAddress}
      >
        <Suspense fallback={<StakingPageLoading />}>
          <StakingPageWrapper />
        </Suspense>
      </ScopeProviderWithInitializer>
    </StakingPageContainer>
  )
}
